'use client'

import { useEffect, useRef } from 'react'

export default function HeroAnalytics() {
  const hasTrackedPageView = useRef(false)

  useEffect(() => {
    if (hasTrackedPageView.current) return

    hasTrackedPageView.current = true
    const searchParams = new URLSearchParams(window.location.search)

    void import('@/lib/analytics').then(({ analytics }) => {
      analytics.page.homepageViewed(
        document.referrer,
        searchParams.get('utm_source') || undefined,
        searchParams.get('utm_campaign') || undefined
      )
    })
  }, [])

  return null
}
